import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoPlayer from './Video/VideoPlayer';
import ShareFeature from './share/ShareFeature';
 
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/video" element={<VideoPlayer />} />
        <Route path="/share/:refId" element={<ShareFeature />} />
      </Routes>
    </Router>
  );
}

export default App;